/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum VeeamRcopProductPrefixes {
    VSPC = 'vspc',
    Agents = 'agents',
    ConnectWiseAutomate = 'cwa',
    ConnectWiseManage = 'cwm',
    Pulse = 'pulse',
    Vbr = 'vbr',
    Grafana = 'grafana',
    ObjectStorage = 'objectStorage',
    Vb = 'vb',
    Vb365Provider = 'vb365Provider',
    Vb365Reseller = 'vb365Reseller',
    Vb365Tenant = 'vb365Tenant',
    VOne = 'vone',
    Flr = 'flr',
}
